import { render, staticRenderFns } from "./channel-reserve-edit-drawer.vue?vue&type=template&id=98a4a7f0&scoped=true"
import script from "./channel-reserve-edit-drawer.vue?vue&type=script&lang=js"
export * from "./channel-reserve-edit-drawer.vue?vue&type=script&lang=js"
import style0 from "./channel-reserve-edit-drawer.vue?vue&type=style&index=0&id=98a4a7f0&prod&scoped=true&lang=css"
import style1 from "./channel-reserve-edit-drawer.vue?vue&type=style&index=1&id=98a4a7f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a4a7f0",
  null
  
)

export default component.exports